export default "__VITE_ASSET__1a05b120__"